import { render } from "./DropboxSVG.vue?vue&type=template&id=469cc6d6"
const script = {}

import exportComponent from "/Users/gordonwong/Shedd/aerocle-client/aerocle-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__